import React from 'react';
import { View } from 'react-native';

import { Stack } from '@/components/layout';
import { createStyles, useScaling } from '@/hooks';
import { guardianColors } from '@/theme/colors';

type PaginationProps = {
  count: number;
  activeIndex: number;
};

export function Pagination({ count, activeIndex }: PaginationProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <Stack direction="row" align="center" justify="center" gap={scale(4)} style={styles.pagination}>
      {Array.from({ length: count }).map((_, index) => (
        <View
          key={index}
          style={[styles.dot, index === activeIndex ? styles.activeDot : styles.inactiveDot]}
        />
      ))}
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  pagination: {
    marginTop: scale(12),
  },
  dot: {
    height: scale(6),
    borderRadius: scale(6),
    borderCurve: 'continuous',
  },
  activeDot: {
    width: scale(24),
    backgroundColor: guardianColors['Main/Main'],
  },
  inactiveDot: {
    width: scale(6),
    backgroundColor: guardianColors['4'],
  },
}));
